import { baseUrl, httpClient } from 'src/pages/admin/providers/AppDataProvider';

import type {
  BanUserVoucherPayload,
  UserVouchersListQuery,
  UserVouchersResponse,
} from './types';
import { normalizeUserVouchers } from './utils';

const resourceBase = 'world-cup/user-vouchers';

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const { json } = await httpClient(`${baseUrl}/${resourceBase}${path}`, options as any);
  return json as T;
}

function buildQueryString(query: UserVouchersListQuery = {}) {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const str = String(value).trim();
    if (!str) return;
    params.append(key, str);
  });
  const search = params.toString();
  return search ? `?${search}` : '';
}

export const userVouchersApi = {
  async list(
    query: UserVouchersListQuery = {},
    signal?: AbortSignal
  ): Promise<UserVouchersResponse> {
    const data = await request<unknown>(`${buildQueryString(query)}`, {
      method: 'GET',
      signal,
    } as any);

    return normalizeUserVouchers(data);
  },

  ban(payload: BanUserVoucherPayload) {
    return request<unknown>('/ban', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
